module.exports = __webpack_public_path__ + "img/image10.52692bae.jpeg";